import { Page, Text, View, StyleSheet } from '@react-pdf/renderer';
import ConfirmationOfEnrolmentProps from './types';
import { BlackLogo } from '../BlackLogo';

const styles = StyleSheet.create({
  page: {
    paddingTop: 40,
    paddingHorizontal: 52,
    paddingBottom: 80,
    fontSize: 12,
    fontFamily: 'Inter',
    lineHeight: 1.6,
  },
  header: {
    flexDirection: 'row',
    justifyContent: 'flex-end',
    marginBottom: 40,
  },
  body: {
    marginTop: 20,
  },
  footer: {
    position: 'absolute',
    bottom: 40,
    left: 52,
    right: 52,
    fontSize: 10,
    flexDirection: 'row',
    justifyContent: 'space-between',
  },
});

function ConfirmationOfEnrolment({
  data,
}: {
  data: ConfirmationOfEnrolmentProps;
}): React.ReactElement {
  return (
    <Page size="A4" style={styles.page} wrap>
      <View style={styles.header}>
        <BlackLogo />
      </View>

      <View style={styles.body}>
        <Text style={{ color: 'grey' }}>{data.generationDate}</Text>

        <Text style={{ marginTop: 20 }}>To whom it may concern,</Text>

        <Text style={{ marginTop: 20 }}>
          This letter confirms that{' '}
          <Text style={{ fontFamily: 'Inter-SemiBold' }}>
            {data.name} (DOB: {data.dob}){' '}
          </Text>
          is currently enrolled into and completing the {data.course} with Duke Education (RTO No.
          22497). Please see the enrolment dates below.
        </Text>

        <Text style={{ marginTop: 20 }}>Enrolment start date: {data.enrolmentStartDate}</Text>
        <Text>Projected enrolment end date: {data.enrolmentEndDate}</Text>

        <Text style={{ marginTop: 20 }}>
          Please don’t hesitate to contact the Customer Experience Team if you have any questions or
          concerns.
        </Text>

        <Text style={{ marginTop: 30 }}>Kind regards,</Text>
        <Text>Customer Experience Team</Text>
        <Text>Duke Education</Text>
      </View>

      <View style={styles.footer}>
        <Text>Duke Education RTO No. 22497</Text>
        <Text>1300 DUKE CO</Text>
        <Text>support@duke.co</Text>
        <Text>Page 1 of 1</Text>
      </View>
    </Page>
  );
}

export default ConfirmationOfEnrolment;
